import PlainInputIcon from './PlainInputIcon';

export default PlainInputIcon;
